import { supportedLngs } from 'i18n'

export default function isLangSelect() {
  if (supportedLngs.length > 1) {
    return true
  } else {
    return false
  }
}
